import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { MessageOutput } from '../model/message.output';

export interface SendMessageInput {
	readonly content: string;
	readonly moduleId?: string;
	readonly documentId?: string;
	readonly visioSessionId?: string;
	readonly participantsId: string[];
}

export interface SendMessageParams {
	input: SendMessageInput;
}

@Injectable({ providedIn: 'root' })
export class SendMessageApiMutation extends ApiMutation<
	MessageOutput,
	SendMessageParams
> {
	client = 'messaging';
	document = gql`
		mutation SendMessage($input: SendMessageInput!) {
			sendMessage(input: $input) {
				id
				content
				moduleId
				authorId
				documentId
				visioSessionId
				participantsId
				updateTimestamp
				creationTimestamp
			}
		}
	`;
	method = 'sendMessage';
}
